import React from 'react';

import ReactDOM from 'react-dom';
import 'assets/styles/color-tokens.css';
import './assets/styles/fonts.scss';
import './assets/styles/variables.scss';
import './index.css';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router } from 'react-router-dom';

import { UserProvider } from './context';
import { LANGUAGE_NAME, TRANSLATIONS } from './locales/en';
import { App } from './views/App';

import { ThemeProvider } from 'context/ThemeProvider/ThemeProvider';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <UserProvider>
        <IntlProvider messages={TRANSLATIONS} locale={LANGUAGE_NAME}>
          <Router>
            <App />
          </Router>
        </IntlProvider>
      </UserProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
